// src/services/assignmentZoneService.js
import { authenticatedFetch } from './api'; // Assuming 'api.js' exports 'authenticatedFetch'

/**
 * Fetches all assignment zones from the backend.
 * @returns {Promise<Array>} A list of zone objects. Each object contains polygonGeoJSON.
 */
export const fetchAssignmentZones = async () => {
    return await authenticatedFetch('/assignment-zones');
};

/**
 * Creates a new assignment zone.
 * @param {object} zoneData - Data for the new zone { name, description, polygonGeoJSON }.
 * @returns {Promise<Object>} The newly created zone object.
 */
export const createAssignmentZone = async (zoneData) => {
    return await authenticatedFetch('/assignment-zones', {
        method: 'POST',
        body: JSON.stringify(zoneData),
    });
};

/**
 * Deletes an assignment zone by its ID.
 * @param {number} id - The ID of the zone to delete.
 * @returns {Promise<void>}
 */
export const deleteAssignmentZone = async (id) => {
    await authenticatedFetch(`/assignment-zones/${id}`, {
        method: 'DELETE',
    });
};

// Add update function if needed later